import { render, staticRenderFns } from "./backDataImageMarkWithMultiDrag.vue?vue&type=template&id=5525ea6e&scoped=true&"
import script from "./backDataImageMarkWithMultiDrag.vue?vue&type=script&lang=js&"
export * from "./backDataImageMarkWithMultiDrag.vue?vue&type=script&lang=js&"
import style0 from "./backDataImageMarkWithMultiDrag.vue?vue&type=style&index=0&id=5525ea6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5525ea6e",
  null
  
)

export default component.exports